import skeleton from '../../../components/skeleton';
import vueSeamlessScroll from "vue-seamless-scroll";
import banner from "../../../components/banner";
import pay from "../../../components/pay";
import QRCode from "../../../components/QRCode";
import './lightMember.less'
export default {
    name: "lightMember",
    data() {
        return {
            videoTitle: '小店的经营也需要数字化营销<br/>但是要更简单、更智能、更超值',
            playerOptions: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: 'https://liantuo-1253818706.cos.ap-nanjing.myqcloud.com/media/skgw/【轻会员】视频.MP4', // url地址
                    },
                ],
                poster: "/img/lightMember/video.png", // 你的封面地址

                width: '100%',
                notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,
                    remainingTimeDisplay: false,
                    fullscreenToggle: true, // 全屏按钮
                },
            },
            info: {
                title1: '设置简单，功能强大',
                txt1: '小精灵营销推出的“轻会员”产品帮助小店打造属于自己的会员体系，玩转营销活动。小店用户也能领取电子会员卡，店主通过发放优惠券、充值有礼、付费会员等智能营销方式提高客单价，拉动储值现金流，实现盈利增长。',
                title2: '笔笔优惠“听得到”',
                txt2: '小精灵语音王4G Pro 不仅播报收款金额，还能够播报优惠金额，特别为小店营销定制。',
                title3: '一次设置，智能运营',
                txt3: '让营销变简单',
                title4Pc: '“小精灵轻会员，给我的小店创造惊喜。”',
                title4Wap: '“小精灵轻会员<br/>给我的小店创造惊喜”',
                txt4: '众多小店正在使用轻会员',
                title5: '仅需1999元 / 年',
                txt5: '一笔小小的投入，可以带来持续的生意增长。'
            },
            card: [
                {
                    title: '全场券',
                    pic: 'img/lightMember/1.png'
                },
                {
                    title: '单品券',
                    pic: 'img/lightMember/2.png'
                },
                {
                    title: '关注有礼',
                    pic: 'img/lightMember/3.png'
                },
                {
                    title: '开卡有礼',
                    pic: 'img/lightMember/4.png'
                },
                {
                    title: '消费有礼',
                    pic: 'img/lightMember/5.png'
                },
                {
                    title: '储值有礼',
                    pic: 'img/lightMember/6.png'
                },
                {
                    title: '智能储值',
                    pic: 'img/lightMember/7.png'
                },
                {
                    title: '消费返利',
                    pic: 'img/lightMember/8.png'
                },
                {
                    title: '会员管理',
                    pic: 'img/lightMember/9.png'
                }
            ],
            rollList: [
                {
                    src: "/img/lightMember/lun1.png",
                    size: 3,
                },
                {
                    src: "/img/lightMember/lun2.png",
                    size: 2,
                },
                {
                    src: "/img/lightMember/lun3.png",
                    size: 4,
                },
                {
                    src: "/img/lightMember/lun4.png",
                    size: 3,
                },
                {
                    src: "/img/lightMember/lun5.png",
                    size: 2,
                },
                {
                    src: "/img/lightMember/lun6.png",
                    size: 4,
                },
            ],
            pay: [
                {
                    title: '平均每月产生小额储值',
                    num: '1043',
                    unit: '元'
                },
                {
                    title: '平均每月核销券数',
                    num: '566',
                    unit: '张'
                },
                {
                    title: '平均提升复购率',
                    num: '16',
                    unit: '%'
                }
            ],
            payBtn: [
                {
                    name: '我是商户',
                    linkTxt: '我要订购',
                    linkHref: 'https://www.wenjuan.com/s/UZBZJvIpp3/#',
                    linkType: 'href'
                },
                {
                    name: '我是服务商',
                    linkTxt: '我要代理轻会员',
                    linkHref: 'https://www.wjx.cn/vm/QMNCfd2.aspx# ',
                    linkType: 'href'
                }
            ]
        }
    },
    components: {
        skeleton,
        banner,
        pay,
        QRCode,
        vueSeamlessScroll
    },
    methods: {

    },
    computed: {
        classOption() {
            return {
                step: 0.7, // 数值越大速度滚动越快
                limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: false, // 是否开启鼠标悬停stop
                direction: 2, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
            };
        }
    }
}
